import React from 'react';
import TextField from '@mui/material/TextField';
import { Controller } from 'react-hook-form';

const FormTextField = ({ name, disabled, variant, ...restProps }) => {
  return (
    <Controller
      name={name}
      render={({ field }) => {
        if (!field.value) field.value = '';
        return (
          <>
            <TextField
              {...restProps}
              {...field}
              disabled={disabled}
              variant="outlined"
            />
          </>
        )
      }}
    />
  )
};

export default FormTextField;
